import React, {  Component } from 'react';

export default class InvalidSalesAgreementOverlayDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }

    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog && this.props.handleDialog('InvalidSalesAgreementOverlayDialog', false);
    }

    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }

    render() {
        const { invalidSAItems } = this.props;
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="invalidSalesAgreementOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Invalid Sales Agreement</h2>
                    {invalidSAItems.map((item, index) => {
                        return <p key={index}>
                            Sales Agreement for the product {item.item} is invalid. Please update.
                        </p>
                    })}
                    <div className="yesButtonContainer">
                      	<a className="yesButton blueButton" onClick={this.closeDialog.bind(this)}>OK</a>
                    </div>
            	</div>
			</div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/components/dialogs/invalidSalesAgreementOverlayDialog.js